export const version = 1774527572874;
export default version;
